import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=3367e75d&scoped=true"
import script from "./AddCompany.vue?vue&type=script&lang=js"
export * from "./AddCompany.vue?vue&type=script&lang=js"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=3367e75d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3367e75d",
  null
  
)

export default component.exports